import { Component, Input, Inject, Optional, OnInit } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';

// A single term + its explanation, for the glossary ("Learn Terms") mode.
export interface InfoTerm {
  label: string;
  message: string;
}

/**
 * Generic, reusable information dialog: an info icon, an optional title, and
 * either a single message (HTML allowed) OR a list of `terms` (a glossary), plus
 * a single Close button. Open it through `commonService.openModel(...)` so it
 * renders as a centred dialog on desktop and a bottom sheet on mobile.
 */
@Component({
  selector: 'ipm-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {
  @Input() title = '';
  @Input() message = '';
  @Input() icon = 'pi pi-info-circle';
  // When provided, the dialog renders these as a definition list instead of the
  // single `message` (used by the campaign "Learn Terms" popup).
  @Input() terms: InfoTerm[] = [];

  constructor(
    private commonService: CommonService,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() @Inject(MAT_BOTTOM_SHEET_DATA) public sheetData: any
  ) {}

  ngOnInit(): void {
    const data = this.dialogData || this.sheetData;
    if (data) {
      if (data.title) this.title = data.title;
      if (data.message) this.message = data.message;
      if (data.icon) this.icon = data.icon;
      if (data.terms) this.terms = data.terms;
    }
  }

  close(): void {
    this.commonService.closePopUp();
  }
}
